












import Vue from 'vue';
// import company, { Company } from '@/modules/buyer/company';
import {
  buyerCompany as company,
  BuyerCompany as Company,
} from 'mostra';

export type DataType = {
  company: Company | null;
  loading: boolean;
  notFound: boolean;
}

export default Vue.extend({
  name: 'buyer-settings-company',
  data(): DataType {
    return {
      company: null,
      loading: true,
      notFound: false,
    };
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;
        this.$loading(true);
        const uid = this.$auth.uid;
        this.company = await company.loadByOwner(uid);
        if (!this.company) {
          this.notFound = true;
          return;
        }
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.loading = false;
        this.$loading(false);
      }
    },
    async submit(companyData: Company) {
      if (companyData && companyData.id && companyData.data) {
        this.$loading(true);
        const uid = this.$auth.uid;
        try {
          this.company = await company.save(uid, companyData);
          this.$success('保存しました');
        } catch (error: any) {
          this.$error('保存に失敗しました', error);
        } finally {
          this.$loading(false);
        }
      }
    },
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    await this.fetchData();
  },
  async mounted() {
    await this.fetchData();
  },
});
